import {
  SelectInput,
  TextArea,
  TextInput,
  UploadBox, SearchSelectInput,
} from "components/core";
import { FormikProps } from "formik";
import { FC } from "react";
import _ from "lodash";
import { Applications } from "apollo/data/applications";
import lodash from "lodash";

type Props = {
  form: FormikProps<any>;
  isDirect?: boolean;
};

export const IssueForm: FC<Props> = ({ form, isDirect = false }) => {

  const rawActions = Applications
    .filter((app) => app.code === form.values.issueApplication)
    .flatMap((item) =>
      item.sections.flatMap((section) =>
        section.permissions.map((permission) => ({
          label: {
            title: `${permission.name} on ${section.name}`
          },
          value: permission.value,
        }))
      )
    );

  const actions = lodash.uniqBy(rawActions, 'value');

  return (
    <div className="space-y-6 divide-y divide-gray-200 flex-1 overflow-y-auto">
      <div className="">
        <span className="text-xs font-light">
          Issue Classification & Priority
        </span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div className="space-y-1">
            <SelectInput
              id="classification"
              label="Issue Classification"
              options={[
                {
                  label: "Select Classification",
                  value: "",
                },
                ...[
                  "UserBasedIssue",
                  "IncorrectDataInputIssue",
                  "SoftwareBugIssue",
                  "EnhancementBasedIssue",
                ].map((classification) => ({
                  label: _.startCase(classification),
                  value: classification,
                })),
              ]}
              {...form}
            />
          </div>

          <div className="space-y-1">
            <SelectInput
              id="priority"
              label="Issue Priority"
              options={[
                {
                  label: "Select Priority",
                  value: "",
                },
                ...["Urgent", "High", "Normal", "Low"].map(
                  (classification) => ({
                    label: _.startCase(classification),
                    value: classification,
                  })
                ),
              ]}
              {...form}
            />
          </div>
        </div>
      </div>

      {
        !isDirect && (
          <div className="pt-2">
            <span className="text-xs font-light">Contact Person Information</span>
            <div className="grid grid-cols-3 gap-6 mt-2">
              <div className="col-span-3">
                <TextInput
                  id="fullName"
                  label="Full Name"
                  type="text"
                  required
                  placeholder="e.g. Kelvin Sowah"
                  {...form}
                />
              </div>

              <div className="col-span-2">
                <TextInput
                  id="email"
                  label="Email Address"
                  type="text"
                  placeholder="e.g. kelvin@office.com"
                  {...form}
                />
              </div>
              <div className="">
                <TextInput
                  id="phoneNumber"
                  label="Phone Number"
                  type="text"
                  placeholder="e.g. 0506339153"
                  required
                  {...form}
                />
              </div>
            </div>
          </div>
        )
      }

      <div className="pt-2">
        <span className="text-xs font-light">Issue Details</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div className="space-y-1">
            <SearchSelectInput
              id="action"
              label="Action"
              placeholder={"Select Action"}
              options={[
                ...actions
              ]}
              {...form}
            />
          </div>
        </div>
        <div className="mt-4">
          <TextArea
            id="issueDetails"
            label="Descriptive details of issue"
            placeholder="eg. I was trying to open the..."
            required
            {...form}
          />
        </div>

        <div className="mt-4">
          <TextArea
            id="expectation"
            label="Expectations"
            placeholder="eg. I expect the modal to..."
            required
            {...form}
          />
        </div>
      </div>

      <div className="pt-6">
        <span className="text-xs font-light">Issue Background</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div className="col-span-2 mb-4">
            <TextArea
              id="issueBackground"
              label="Background"
              placeholder="e.g. Upon launch of the console, the page..."
              required
              {...form}
            />
          </div>
          <div className="col-span-2">
            <UploadBox
              label="Attachments"
              multiple
              id={"attachments"}
              {...form}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
